import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { VelocityLimitListInterface } from '../types/velocity-limit-list';
import {
  VelocityLimitListFilter,
  defaultVelocityLimitListFilter,
} from '../types/velocity-limit-list-filter';

export const VELOCITY_LIMIT_LIST_STATE = 'velocityLimitList';

export interface VelocityLimitListState {
  filter: VelocityLimitListFilter;
  dataSource: DataSource<VelocityLimitListInterface[]>;
}

export const initialDataSource: DataSource<VelocityLimitListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialVelocityLimitListState: VelocityLimitListState =
  Object.freeze({
    filter: defaultVelocityLimitListFilter,
    dataSource: {
      ...initialDataSource,
    },
  });
